// extracted by mini-css-extract-plugin
export default {"Horizontal30pct70pct":"Horizontal30pct70pct_Horizontal30pct70pct__daJwA"};